export default "__VITE_ASSET__HnIxpGlp__"